/**
 * 修改平台邮箱账号密码
 */
export const changePwd = '/user/modify/password';
/**
 * 引继码生成
 */
export const inherit = '/user/inherit/password';
/**
 * 发送联系邮箱验证码
 */
export const sendEmailCode = '/user/contactEmail/sendCode';
/**
 * 验证联系邮箱验证码
 */
export const checkEmailCode = '/user/contactEmail/checkCode';
/**
 * 获取用户消费记录
 */
export const getPOrderList = '/user/get/purchaseOrderList';
/**
 * 获取用户平台币充值记录
 */
export const getROrderList = '/user/get/rechargeOrderList';
/**
 * 平台游客账号绑定平台邮箱账号
 */
export const relateEmail = '/user/relate/email';
/**
 * 第三方账号升级平台邮箱账号
 */
export const upgradeEmail = '/user/upgrade/email';
/**
 * 平台账号登陆领取积分入口
 */
export const integralAward = '/user/integral/award';
/**
 * 获取三方支付登录码
 */
export const getLogCode = '/user/thirdPay/login/code';
/**
 * 获取三方支付登录码白名单
 */
export const checkWhitelist = '/thirdPay/whitelist/config/switch';